import {
  FitPeriod,
  GanttParameterVO,
} from '../../../../domain/value-object/GanttParameterVO'
import { RootGanttParameterLoad } from '../../../../store/ganttParameterState'

export const PROJECT_ROOT_FIT_TOKEN = 'PROJECT_ROOT'

/** 初回表示の合わせを1回だけ行うための目印。ルートの表示設定を読み込むたびに新しくなる */
export type PendingFitToken =
  | RootGanttParameterLoad
  | typeof PROJECT_ROOT_FIT_TOKEN

export type InitialFitCondition = {
  isRememberRange: boolean | undefined
  isProjectSaved: boolean | undefined
  isRootBodyLoaded: boolean
  rootProjectPlanUuid: string | undefined
  rootLoad: RootGanttParameterLoad | undefined
}

export const resolvePendingFitToken = ({
  isRememberRange,
  isProjectSaved,
  isRootBodyLoaded,
  rootProjectPlanUuid,
  rootLoad,
}: InitialFitCondition): PendingFitToken | undefined => {
  if (!isRememberRange || isProjectSaved === undefined || !isRootBodyLoaded) {
    return undefined
  }
  if (!rootProjectPlanUuid) {
    return isProjectSaved ? undefined : PROJECT_ROOT_FIT_TOKEN
  }
  const isUnsavedRoot =
    rootLoad?.rootProjectPlanUuid === rootProjectPlanUuid && !rootLoad.isSaved
  return isUnsavedRoot ? rootLoad : undefined
}

export type InitialFitPlan = {
  token: PendingFitToken
  /** 保存する値。合わせる期間がないときは undefined で、目印だけを処理済みにする */
  parameter: GanttParameterVO | undefined
}

export const planInitialGanttFit = ({
  pendingToken,
  handledToken,
  fitPeriod,
  current,
  fiscalStartMonth,
}: {
  pendingToken: PendingFitToken | undefined
  handledToken: PendingFitToken | undefined
  fitPeriod: FitPeriod | undefined
  current: GanttParameterVO
  fiscalStartMonth: number
}): InitialFitPlan | undefined => {
  if (!pendingToken || pendingToken === handledToken) return undefined
  return {
    token: pendingToken,
    parameter: fitPeriod
      ? current.fitTo(fitPeriod, fiscalStartMonth)
      : undefined,
  }
}
